module.exports = __webpack_public_path__ + "static/media/2.8a7df260.jpg";